import React from "react";

const ModeCard = ({ title, checked, onChange, children }) => {
  return (
    <div className={`card p-3 ${checked ? "border-primary" : ""}`}>
      <div className="form-check mb-2">
        <input
          className="form-check-input me-2"
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          id={`${title}Check`}
        />
        <label className="form-check-label" htmlFor={`${title}Check`}>
          {title}
        </label>
      </div>
      {checked && children}
    </div>
  );
};

export default ModeCard;
